import { NavLink } from 'react-router-dom';

const EDR_NAV_LINKS = [
  { label: 'EDR Project Effort', path: '/mis/edr-project-effort' },
  { label: 'Project Allocation % Report', path: '/mis/project-allocation' },
];

const EDRActivityReportToolbar = () => (
  <div className="edr-toolbar">
    <div className="links">
      {EDR_NAV_LINKS.map(({ label, path }) => (
        <NavLink
          key={path}
          to={path}
          className={({ isActive }) =>
            `link${isActive ? ' link--active' : ''}`
          }
        >
          {label}
        </NavLink>
      ))}
    </div>
  </div>
);

export default EDRActivityReportToolbar;
